$(function() {
	console.log(APP.name);

    showCode($('._js-ui-codes'), false);
    selectStyler();
    inputFile();
    map('_js-map', 55.751574, 37.573856);
    map('_js-qualification-centers-map', 55.751574, 37.573856);
    userListElement();
    //calendar();
    initCookiePopup();
    dateRange();
    datePick();
    scroll2();
    inputTel($('._js-input-tel'));
    inputPassportSeries($('._js-input-passport-series'));
    inputPassportNumber($('._js-input-passport-number'));
    inputTelModalReg($('._js-input-tel-reg'));
    inputDate($('._js-input-date, ._js-input-birth-date'));
    inputTime($('._js-input-time'));
    inputSmsCofirm($('._js-sms-confirm'));
    sendSmsButton();
    headerSearch();
    mobileAside(1190);
    list2select($('._js-aside-nav'), 1024, 'Выберите пункт меню');
    accordion($('._js-faq-accordion'), false); //true - stands for that all other accordions will collapse
    accordion($('._js-aside-accordion'), false);
    accordion($('._js-docs-accordion'), false);
    accordion($('._js-qualifications-list'), false);
    accordionAny($('._js-pers-file-v2-accordion'), false);
    accordionBlockWithDoc($('._js-block-with-doc-accordion'), false);
    //common accordions
    accordion($('._js-acc-collapsible'), true);
    accordion($('._js-acc-non-collapsible'), false);
    addInputFile();
    locationSelect('_location-select');
    matching();
    sortable();
    stateWebsites();
    stateWebsitesNav(1190);
    sliderTabs();
    scrollIt();
    multiselect();
    initStats();

    /*создает кастомные скроллбары в указанных контейнерах*/
    if ( $('.scrollable-block').length ) {
        let scrollbars = new CustomScrollbar($('.scrollable-block'));
    }

    //  связывает чекбоксы в модалке с реальными в форме
    $(document).on('change', '.js-video-qual', function() {
      $(`.js-checkbox-list input[value=${this.value}]`)[0].checked = this.checked;
    });

    $('#_navigation').on('click', '#_navigation-button', function () {
        $('#_navigation-dropdown').toggleClass('_active');
        $('#_navigation-button').toggleClass('_active');
    });

    //disable links
    $('.isDisabled').on('click', function(e){
      e.preventDefault();
    });

    //modals
    $('.js-modal-link').on('click', function(e){
      if ($(this).attr('href')) {
        e.preventDefault();
      }
      var target = $('[data-modal='+ $(this).data('target') +']');
      modal(target);
    });

    //radio modal
    $('.js-modal-control').on('change', function(){
      if (this.checked) {
        var target = $('[data-modal='+ $(this).data('target') +']');
        modal(target);
      }
    });

    $(document).on('click', '.js-link-print-block', function(e) {
        e.preventDefault();

        printDiv('.js-print-block');
    });

    // $.fn.datepicker.language['ru'] =  {
    //     days: ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'],
    //     daysShort: ['Вос','Пон','Вто','Сре','Чет','Пят','Суб'],
    //     daysMin: ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'],
    //     months: ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
    //     monthsShort: ['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек'],
    //     today: 'Сегодня',
    //     clear: 'Очистить',
    //     dateFormat: 'dd.mm.yyyy',
    //     timeFormat: 'hh:ii',
    //     firstDay: 1
    // };

    $('.js-calendar').datepicker( $.datepicker.regional[ 'ru' ] );
    // $.datepicker.setDefaults($.datepicker.regional['ru']);

    function printDiv(divName) {
        var printContents = document.querySelector(divName).innerHTML;
        var originalContents = document.body.innerHTML;

        document.body.innerHTML = printContents;

        window.print();

        document.body.innerHTML = originalContents;

        if ($('.js-reload').length) {
            $('.js-reload').click();
        }
    }
});

$(window).on('load resize', function(){
    responseNavigation();
    navigationSurf(1190);

}).trigger('resize');


$(function() {
    if (!$('.js-schedule-datepicker').length) return;


    // Месяцы для вывода в ячейках
    const monthNames = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
    ];

    // для добавления класса выбраной ячейки
    let currentSelectedDate = null;

    // для показа формы
    let dateChoosen = false;

    //функция в компоненте
    window.getExams().then((resp) => {
        $('.js-schedule-datepicker').datepicker({
            inline: true,
            language: 'ru',
            changeYear: false,
            minDate: new Date(),
            selectOtherMonths: true,
            showOtherMonths: true,
            prevHtml: `<svg viewbox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><path d="M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15zm0 28.125C7.751 28.125 1.875 22.249 1.875 15S7.751 1.875 15 1.875 28.125 7.751 28.125 15 22.249 28.125 15 28.125z"/><path d="M17.147 6.844l-7.5 7.5a.937.937 0 000 1.322l7.5 7.5 1.322-1.332L11.634 15l6.835-6.834-1.322-1.322z"/></svg>`,
            nextHtml: `<svg viewbox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><path d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm0-28.125c7.249 0 13.125 5.876 13.125 13.125S22.249 28.125 15 28.125 1.875 22.249 1.875 15 7.751 1.875 15 1.875z"/><path d="M12.853 23.156l7.5-7.5a.937.937 0 000-1.322l-7.5-7.5-1.322 1.332L18.366 15l-6.835 6.834 1.322 1.322z"/></svg>`,
            navTitles: {
                days: 'MM yyyy',
            },
            onSelect: function(formattedDate, date, inst) {
            },

            // Рендер кастомных ячеек
            onRenderCell: function (date, cellType) {
                if (cellType === 'day') {
                    const month = monthNames[date.getMonth()];
                    // Находим экзамен по текущему значению даты ячейки
                    const exam = resp.find((item) => date.toDateString() === (new Date(item.date)).toDateString());

                    if (exam && exam.time && exam.time.length) {
                        return {
                            html: `<div class="datepicker__date">
                                <div class="exam-choice">
                                    <span class="exam-choice__label js-open-dropdown">
                                        <span>${ date.getDate() } <span class="_tablet-hidden">${ month } </span></span>
                                        <svg viewbox="0 0 30 30" class="exam-choice__icon">
                                            <path d="M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm0-28.125c7.249 0 13.125 5.876 13.125 13.125S22.249 28.125 15 28.125 1.875 22.249 1.875 15 7.751 1.875 15 1.875z"/><path d="M12.853 23.156l7.5-7.5a.937.937 0 000-1.322l-7.5-7.5-1.322 1.332L18.366 15l-6.835 6.834 1.322 1.322z"/>
                                        </svg>
                                    </span>

                                    <div class="exam-choice__dropdown">
                                        <div class="exam-choice-list">
                                            ${ exam.time && exam.time.map((item, iindex) => (`<div class="exam-choice-list__item">
                                            <button class="exam-choice-list__label js-choose-time" data-id="${exam.id}" data-comp="${exam.comps[iindex]}" data-date="${exam.date}" data-time="${item}">${item}</button>
                                            </div>`)).join('') }
                                        </div>
                                    </div>
                                </div>
                            </div>`,
                            classes: getExtraClasses(date),
                        }
                    }

                    return {
                        html: `<div class="datepicker__date ">${ date.getDate() } <span class="_tablet-hidden">${ month }</span></div>`,
                        disabled: true
                    }
                }
            },
        });

        function getExtraClasses(date) {
            if(currentSelectedDate && currentSelectedDate.getDate() === date.getDate() && currentSelectedDate.getMonth() === date.getMonth()) {
              return '_selected _with-exam'
          } else {
            return '_with-exam'
          }
        }

        document.addEventListener('click', function(ev) {
          const target = ev.target.closest('.js-choose-time');
          if(!target) return;

          const $form = $('.js-exam-form');

          // show form

          if(!dateChoosen) {
            $form.removeClass('_hidden');
            dateChoosen = true;
          }

          const monthNames = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
          ];

          const date = new Date(target.dataset.date);
          let time = target.dataset.time;
          $("#comp").val(target.dataset.comp);
          date.setHours(parseInt(time));
          date.setMinutes(parseInt(time.slice(-2)));

          $("#time").val(date.toLocaleString());

          // для вычисления выбранной ячейки
          currentSelectedDate = date;

          $form.find('.js-date-text').html(`
            ${date.getDate()}&nbsp;${monthNames[date.getMonth()]} в&nbsp;<span class="exam-form__time">${time}</span>
          `);

          $form.find('.js-date-input').val(date);


          const scheduleDatepicker = $('.js-schedule-datepicker').datepicker().data('datepicker');
          scheduleDatepicker.clear();
        });
    });

    // click outside
    $('body').on('click', function(ev) {
      if(!ev.target.closest('.datepicker--cell-day')) {
        var scheduleDatepicker = $('.js-schedule-datepicker').datepicker().data('datepicker');
        scheduleDatepicker.clear();
      }
    });
});
